// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:100,300,400,700,900);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*:before,
*:after {
  box-sizing: border-box;
}

ion-content {
  overflow-x: hidden;
  overflow-y: hidden;
  font-family: Calibri !important;
  background-color: var(--color-blue-2-light);
}

digim-dispatcher-home-card {
  padding: 2px;
}
digim-dispatcher-home-card ion-card-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
digim-dispatcher-home-card ion-card-content ion-row {
  height: 100px;
  width: 100% !important;
  padding: 10px;
}
digim-dispatcher-home-card ion-card-content ion-row ion-card {
  height: 100px;
  width: 100%;
}

.digim-button-1 {
  --background: var(--color-blue-1-light);
  --border-radius: 5px;
  font-weight: lighter;
  height: 32px;
  width: 85px;
  text-transform: capitalize;
  --border-color: var(--color-blue-1-dark);
  --border-style: solid;
  --border-width: 1px;
}

.cards-wrapper {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 310px);
  justify-content: center;
  align-content: start;
  grid-gap: 0 1.15vw;
  margin: 0 !important;
  padding: 0 !important;
  overflow-y: scroll;
  z-index: 1;
  transition-property: transform;
  box-sizing: content-box;
  background: var(--color-blue-6-light);
}

.cards-wrapper > * {
  margin-top: 1.15vw;
}

@media screen and (max-width: 360px) {
  .cards-wrapper {
    grid-gap: 0 0;
  }
  .cards-wrapper > * {
    margin-top: 0 !important;
    margin: 0 !important;
  }
}
ion-card {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  margin: 0 5px;
  height: 100%;
  overflow: visible;
}

ion-content {
  overflow-y: auto;
}

.digim-card-heading {
  font-size: 22px;
  color: var(--color-black-light);
  display: inline-block;
  text-transform: capitalize;
  font-family: Calibri;
  width: 90%;
  font-weight: 600;
}

ion-card-header {
  border-radius: 10px 10px 0 0;
  background-color: var(--color-blue-7-light);
  padding: 10px 10px 5px 10px;
}

ion-card-header ion-icon {
  font-size: 22px;
  color: var(--color-gray-4-light);
  cursor: pointer;
  vertical-align: middle;
}

.digim-small-text {
  font-size: 10px;
  font-weight: normal;
  padding: 0px 0 0px 5px;
  color: var(--color-black-light);
  font-size: 13px;
  text-align: center;
  width: 100%;
  font-weight: bold;
  margin-bottom: 10px;
}

.digim-ionic-card-center ion-card-content {
  height: 200px;
  width: 100%;
}

.digim-text-card-title {
  display: block;
  font-size: 4em;
  color: var(--color-black-light);
  text-align: center;
  width: 100%;
  font-family: Calibri;
}

.digim-text-card-title-small {
  display: block;
  font-size: 32px;
  width: 100%;
  color: var(--color-black-light);
  text-align: center;
  font-family: Calibri;
}

.digim-card-title-hour-text {
  display: block;
  font-size: 1rem;
  width: 100%;
  color: var(--color-black-light);
  text-align: center;
  font-family: Calibri;
  margin: 15px 0;
  font-weight: 600;
}

.blue-80 {
  border-bottom: 2px solid var(--color-blue-2-light);
  width: 80%;
  margin: auto;
}

.weather-wrapper {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr 1fr auto;
}

@media only screen and (min-device-width: 834px) and (max-device-width: 1366px) and (orientation: portrait) {
  .digim-ionic-card-center ion-card {
    height: 330px;
  }
}
@media only screen and (min-device-width: 834px) and (max-device-width: 1366px) and (orientation: landscape) {
  .digim-ionic-card-center ion-card {
    height: 330px;
  }
}
/* Safari 10.1+ */
@media not all and (-webkit-min-device-pixel-ratio: 0), not all and (min-resolution: 0.001dpcm) {
  ion-card {
    height: 450px;
  }
}
.responsive_card {
  background: none !important;
}

@media (min-width: 768px) {
  .digim-card-heading {
    padding-bottom: 10px;
  }
}
.digim-notification-top-right {
  position: absolute;
  top: 1px;
  right: 1px;
}

.responsive_card .digim-notification-top-right {
  height: 30px;
  transition: 0.6s;
  width: 30px;
  font-size: 16px;
  right: -10px;
  z-index: 1;
  top: -10px;
}

.noLocation {
  padding: 0px 10px;
  font-size: 16px;
  color: var(--color-gray-5-light);
  text-align: center;
}

.lockedScreen {
  text-align: center;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
}
.lockedScreen .lockedContainer {
  background-color: var(--color-blue-0-light);
  padding: 20px;
  border-radius: 10px;
}
.lockedScreen .lock-icon {
  width: 150px;
  height: 150px;
  color: var(--color-blue-1-light);
}
.lockedScreen .oops {
  color: var(--color-red-light);
}
.lockedScreen .oops ion-icon {
  vertical-align: middle;
  width: 36px;
  height: 36px;
}
.lockedScreen p {
  font-size: 22px;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 980px) {
  .digim-button-1 {
    font-size: 13px;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) and (orientation: landscape) {
  .digim-button-1 {
    font-size: 15px;
  }
}
.digim-card-heading img {
  vertical-align: middle;
  margin-right: 8px;
  text-align: left;
}

.notificationHome_section {
  padding: 0 10px;
  font-size: 14px;
  height: 160px;
  overflow-y: auto;
  display: block;
  line-height: 1.3;
  color: var(--color-black-light);
}

.notificationHome_section ul {
  padding: 0;
  margin-left: 20px;
  list-style-type: disc;
  margin-top: 5px;
  margin-bottom: 5px;
}

.notificationHome_section ul li {
  margin: 5px 0;
}

.align-center {
  text-align: center;
  padding-top: 25%;
  font-size: 20px;
}

.float-icon-left {
  position: fixed;
  z-index: 55;
  bottom: 0;
  cursor: pointer;
  right: 0;
  background-color: var(--color-red-light);
  padding: 7px;
  border-radius: 5px 0 0 5px;
}
.float-icon-left ion-icon {
  width: 25px;
  margin-right: 3px;
  vertical-align: middle;
  height: 25px;
}

/* dark theme styles */
.digim-ion-content.dark {
  background-color: var(--color-blue-2-dark);
}

.dark .digim-button-1 {
  --background: var(--color-blue-1-dark);
  --border-color: var(--color-blue-1-light);
}
.dark .cards-wrapper {
  background: var(--color-blue-6-dark);
}
.dark .digim-card-heading {
  color: var(--color-black-dark);
}
.dark ion-card-header {
  background-color: var(--color-blue-7-dark);
}
.dark ion-card-header ion-icon {
  color: var(--color-gray-4-dark);
}
.dark .digim-small-text {
  color: var(--color-black-dark);
}
.dark .digim-text-card-title {
  color: var(--color-black-dark);
}
.dark .digim-text-card-title-small {
  color: var(--color-black-dark);
}
.dark .digim-card-title-hour-text {
  color: var(--color-black-dark);
}
.dark .blue-80 {
  border-bottom: 2px solid var(--color-blue-2-dark);
}
.dark .noLocation {
  color: var(--color-gray-5-dark);
}
.dark .lockedScreen .lockedContainer {
  background-color: var(--color-blue-0-dark);
}
.dark .lockedScreen .lock-icon {
  color: var(--color-blue-1-dark);
}
.dark .lockedScreen .oops {
  color: var(--color-red-dark);
}
.dark .notificationHome_section {
  color: var(--color-black-dark);
}
.dark .float-icon-left {
  background-color: var(--color-red-dark);
}`, "",{"version":3,"sources":["webpack://./src/app/containers/home/home.page.scss","webpack://./../../../../../Ryan%20Ticer/source/repos/seacom3/ui/src/app/containers/home/home.page.scss"],"names":[],"mappings":"AAMA;;;EAGE,sBAAA;ACJF;;ADOA;EACE,kBAAA;EACA,kBAAA;EACA,+BAAA;EACA,2CAAA;ACJF;;ADOA;EACE,YAAA;ACJF;ADME;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;ACLJ;ADOI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;ACLN;ADOM;EACE,aAAA;EACA,WAAA;ACLR;;ADYA;EACE,uCAAA;EACA,oBAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;ACTF;;ADaA;EACE,WAAA;EACA,YAAA;EAEA,aAAA;EACA,+CAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,8BAAA;EACA,uBAAA;EACA,qCAAA;ACXF;;ADcA;EACE,kBAAA;ACXF;;ADcA;EACE;IACE,aAAA;ECXF;EDaA;IACE,wBAAA;IACA,oBAAA;ECXF;AACF;ADeA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;ACbF;;ADiBA;EAEE,gBAAA;ACfF;;ADkBA;EACE,eAAA;EACA,+BAAA;EACA,qBAAA;EACA,0BAAA;EACA,oBAAA;EACA,UAAA;EACA,gBAAA;ACfF;;ADkBA;EACE,4BAAA;EACA,2CAAA;EACA,2BAAA;ACfF;;ADkBA;EACE,eAAA;EACA,gCAAA;EACA,eAAA;EACA,sBAAA;ACfF;;ADkBA;EACE,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;ACfF;;ADkBA;EACE,aAAA;EACA,WAAA;ACfF;;ADkBA;EACE,cAAA;EACA,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;ACfF;;ADmBA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,oBAAA;AChBF;;ADmBA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;AChBF;;ADmBA;EACE,kDAAA;EACA,UAAA;EACA,YAAA;AChBF;;ADmBA;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,wCAAA;AChBF;;ADmBA;EACE;IACE,aAAA;EChBF;AACF;ADmBA;EACE;IACE,aAAA;ECjBF;AACF;ADoBA,iBAAA;AACA;EACE;IACE,aAAA;EClBF;AACF;ADqBA;EACE,2BAAA;ACnBF;;ADuBA;EACE;IACE,oBAAA;ECpBF;AACF;ADuBA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;ACrBF;;ADwBA;EACE,YAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;ACrBF;;ADwBA;EACE,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;ACrBF;;ADwBA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ACrBF;ADuBE;EACE,2CAAA;EACA,aAAA;EACA,mBAAA;ACrBJ;ADwBE;EACE,YAAA;EACA,aAAA;EACA,gCAAA;ACtBJ;ADyBE;EACE,6BAAA;ACvBJ;ADyBI;EACE,sBAAA;EACA,WAAA;EACA,YAAA;ACvBN;AD2BE;EACE,eAAA;ACzBJ;;AD6BA;EACE;IACE,eAAA;EC1BF;AACF;AD6BA;EACE;IACE,eAAA;EC3BF;AACF;AD8BA;EACE,sBAAA;EACA,iBAAA;EACA,gBAAA;AC5BF;;AD+BA;EACE,eAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,+BAAA;AC5BF;;AD+BA;EACE,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AC5BF;;AD+BA;EAEE,aAAA;AC7BF;;ADgCA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AC7BF;;ADgCA;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,QAAA;EACA,wCAAA;EACA,YAAA;EACA,0BAAA;AC7BF;AD+BE;EACE,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;AC7BJ;;ADiCA,sBAAA;AACA;EACE,0CAAA;AC9BF;;ADkCE;EACE,sCAAA;EACA,yCAAA;AC/BJ;ADkCE;EACE,oCAAA;AChCJ;ADmCE;EACE,8BAAA;ACjCJ;ADoCE;EACE,0CAAA;AClCJ;ADqCE;EACE,+BAAA;ACnCJ;ADsCE;EACE,8BAAA;ACpCJ;ADuCE;EACE,8BAAA;ACrCJ;ADwCE;EACE,8BAAA;ACtCJ;ADyCE;EACE,8BAAA;ACvCJ;AD0CE;EACE,iDAAA;ACxCJ;AD2CE;EACE,+BAAA;ACzCJ;AD6CI;EACE,0CAAA;AC3CN;AD8CI;EACE,+BAAA;AC5CN;AD+CI;EACE,4BAAA;AC7CN;ADiDE;EACE,8BAAA;AC/CJ;ADkDE;EACE,uCAAA;AChDJ","sourcesContent":["@import url(https://fonts.googleapis.com/css?family=Lato:100,300,400,700,900);\r\n\r\n$COLOR_4: #000000;\r\n\r\n$color1: #C8DAE6;\r\n\r\n*,\r\n*:before,\r\n*:after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nion-content {\r\n  overflow-x: hidden;\r\n  overflow-y: hidden;\r\n  font-family: Calibri !important;\r\n  background-color: var(--color-blue-2-light);\r\n}\r\n\r\ndigim-dispatcher-home-card {\r\n  padding: 2px;\r\n\r\n  ion-card-content {\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    ion-row {\r\n      height: 100px;\r\n      width: 100% !important;\r\n      padding: 10px;\r\n\r\n      ion-card {\r\n        height: 100px;\r\n        width: 100%;\r\n      }\r\n\r\n    }\r\n  }\r\n}\r\n\r\n.digim-button-1 {\r\n  --background: var(--color-blue-1-light);\r\n  --border-radius: 5px;\r\n  font-weight: lighter;\r\n  height: 32px;\r\n  width: 85px;\r\n  text-transform: capitalize;\r\n  --border-color: var(--color-blue-1-dark);\r\n  --border-style: solid;\r\n  --border-width: 1px;\r\n}\r\n\r\n//To keep height of all the cards same\r\n.cards-wrapper {\r\n  width: 100%;\r\n  height: 100%;\r\n  \r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, 310px);\r\n  justify-content: center;\r\n  align-content: start;\r\n  grid-gap: 0 1.15vw;\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  overflow-y: scroll;\r\n  z-index: 1;\r\n  transition-property: transform;\r\n  box-sizing: content-box;\r\n  background: var(--color-blue-6-light);\r\n}\r\n\r\n.cards-wrapper > * {\r\n  margin-top: 1.15vw;\r\n}\r\n\r\n@media screen and (max-width: 360px) {\r\n  .cards-wrapper {\r\n    grid-gap: 0 0;\r\n  }\r\n  .cards-wrapper > * {\r\n    margin-top: 0 !important;\r\n    margin: 0 !important;\r\n  }\r\n  \r\n}\r\n\r\nion-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-radius: 10px;\r\n  margin: 0 5px;\r\n  height: 100%;\r\n  overflow: visible;\r\n}\r\n\r\n//  Disable scrolling if page is larger than the device screen\r\nion-content {\r\n  //--overflow: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.digim-card-heading {\r\n  font-size: 22px;\r\n  color: var(--color-black-light);\r\n  display: inline-block;\r\n  text-transform: capitalize;\r\n  font-family: Calibri;\r\n  width: 90%;\r\n  font-weight: 600;\r\n}\r\n\r\nion-card-header {\r\n  border-radius: 10px 10px 0 0;\r\n  background-color: var(--color-blue-7-light);\r\n  padding: 10px 10px 5px 10px;\r\n}\r\n\r\nion-card-header ion-icon {\r\n  font-size: 22px;\r\n  color: var(--color-gray-4-light);\r\n  cursor: pointer;\r\n  vertical-align: middle;\r\n}\r\n\r\n.digim-small-text {\r\n  font-size: 10px;\r\n  font-weight: normal;\r\n  padding: 0px 0 0px 5px;\r\n  color: var(--color-black-light);\r\n  font-size: 13px;\r\n  text-align: center;\r\n  width: 100%;\r\n  font-weight: bold;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.digim-ionic-card-center ion-card-content {\r\n  height: 200px;\r\n  width: 100%\r\n}\r\n\r\n.digim-text-card-title {\r\n  display: block;\r\n  font-size: 4em;\r\n  color: var(--color-black-light);\r\n  text-align: center;\r\n  width: 100%;\r\n  font-family: Calibri;\r\n  // line-height: 110px;\r\n}\r\n\r\n.digim-text-card-title-small {\r\n  display: block;\r\n  font-size: 32px;\r\n  width: 100%;\r\n  color: var(--color-black-light);\r\n  text-align: center;\r\n  font-family: Calibri;\r\n}\r\n\r\n.digim-card-title-hour-text {\r\n  display: block;\r\n  font-size: 1rem;\r\n  width: 100%;\r\n  color: var(--color-black-light);\r\n  text-align: center;\r\n  font-family: Calibri;\r\n  margin: 15px 0;\r\n  font-weight: 600;\r\n}\r\n\r\n.blue-80 {\r\n  border-bottom: 2px solid var(--color-blue-2-light);\r\n  width: 80%;\r\n  margin: auto;\r\n}\r\n\r\n.weather-wrapper {\r\n  height: 100%;\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: grid;\r\n  grid-template-rows: 1fr 1fr 1fr 1fr auto;\r\n}\r\n\r\n@media only screen and (min-device-width : 834px) and (max-device-width : 1366px) and (orientation : portrait) {\r\n  .digim-ionic-card-center ion-card {\r\n    height: 330px;\r\n  }\r\n}\r\n\r\n@media only screen and (min-device-width : 834px) and (max-device-width : 1366px) and (orientation : landscape) {\r\n  .digim-ionic-card-center ion-card {\r\n    height: 330px;\r\n  }\r\n}\r\n\r\n/* Safari 10.1+ */\r\n@media not all and (min-resolution:.001dpcm) {\r\n  ion-card {\r\n    height: 450px;\r\n  }\r\n}\r\n\r\n.responsive_card {\r\n  background: none !important;\r\n}\r\n\r\n// Medium devices (tablets, 768px and up)\r\n@media (min-width: 768px) {\r\n  .digim-card-heading {\r\n    padding-bottom: 10px;\r\n  }\r\n}\r\n\r\n.digim-notification-top-right {\r\n  position: absolute;\r\n  top: 1px;\r\n  right: 1px;\r\n}\r\n\r\n.responsive_card .digim-notification-top-right {\r\n  height: 30px;\r\n  transition: 0.6s;\r\n  width: 30px;\r\n  font-size: 16px;\r\n  right: -10px;\r\n  z-index: 1;\r\n  top: -10px;\r\n}\r\n\r\n.noLocation {\r\n  padding: 0px 10px;\r\n  font-size: 16px;\r\n  color: var(--color-gray-5-light);\r\n  text-align: center\r\n}\r\n\r\n.lockedScreen {\r\n  text-align: center;\r\n  margin-top: 50px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n\r\n  .lockedContainer {\r\n    background-color: var(--color-blue-0-light);\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .lock-icon {\r\n    width: 150px;\r\n    height: 150px;\r\n    color: var(--color-blue-1-light);\r\n  }\r\n\r\n  .oops {\r\n    color: var(--color-red-light);\r\n\r\n    ion-icon {\r\n      vertical-align: middle;\r\n      width: 36px;\r\n      height: 36px;\r\n    }\r\n  }\r\n\r\n  p {\r\n    font-size: 22px;\r\n  }\r\n}\r\n\r\n@media only screen and (min-device-width: 768px) and (max-device-width: 980px) {\r\n  .digim-button-1 {\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) and (orientation: landscape) {\r\n  .digim-button-1 {\r\n    font-size: 15px;\r\n  }\r\n}\r\n\r\n.digim-card-heading img {\r\n  vertical-align: middle;\r\n  margin-right: 8px;\r\n  text-align: left;\r\n}\r\n\r\n.notificationHome_section {\r\n  padding: 0 10px;\r\n  font-size: 14px;\r\n  height: 160px;\r\n  overflow-y: auto;\r\n  display: block;\r\n  line-height: 1.3;\r\n  color: var(--color-black-light);\r\n}\r\n\r\n.notificationHome_section ul {\r\n  padding: 0;\r\n  margin-left: 20px;\r\n  list-style-type: disc;\r\n  margin-top: 5px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.notificationHome_section ul li {\r\n  //display: block; \r\n  margin: 5px 0;\r\n}\r\n\r\n.align-center {\r\n  text-align: center;\r\n  padding-top: 25%;\r\n  font-size: 20px;\r\n}\r\n\r\n.float-icon-left {\r\n  position: fixed;\r\n  z-index: 55;\r\n  bottom: 0;\r\n  cursor: pointer;\r\n  right: 0;\r\n  background-color: var(--color-red-light);\r\n  padding: 7px;\r\n  border-radius: 5px 0 0 5px;\r\n\r\n  ion-icon {\r\n    width: 25px;\r\n    margin-right: 3px;\r\n    vertical-align: middle;\r\n    height: 25px;\r\n  }\r\n}\r\n\r\n/* dark theme styles */\r\n.digim-ion-content.dark {\r\n  background-color: var(--color-blue-2-dark);\r\n}\r\n\r\n.dark {   \r\n  .digim-button-1 {\r\n    --background: var(--color-blue-1-dark);\r\n    --border-color: var(--color-blue-1-light);\r\n  }\r\n  \r\n  .cards-wrapper {\r\n    background: var(--color-blue-6-dark);\r\n  }\r\n    \r\n  .digim-card-heading {\r\n    color: var(--color-black-dark);\r\n  }\r\n  \r\n  ion-card-header {\r\n    background-color: var(--color-blue-7-dark);\r\n  }\r\n  \r\n  ion-card-header ion-icon {\r\n    color: var(--color-gray-4-dark);\r\n  }\r\n  \r\n  .digim-small-text {\r\n    color: var(--color-black-dark);\r\n  }\r\n  \r\n  .digim-text-card-title {\r\n    color: var(--color-black-dark);\r\n  }\r\n  \r\n  .digim-text-card-title-small {\r\n    color: var(--color-black-dark);\r\n  }\r\n  \r\n  .digim-card-title-hour-text {\r\n    color: var(--color-black-dark);\r\n  }\r\n  \r\n  .blue-80 {\r\n    border-bottom: 2px solid var(--color-blue-2-dark);\r\n  }\r\n  \r\n  .noLocation {\r\n    color: var(--color-gray-5-dark);\r\n  }\r\n  \r\n  .lockedScreen {\r\n    .lockedContainer {\r\n      background-color: var(--color-blue-0-dark);\r\n    }\r\n  \r\n    .lock-icon {\r\n      color: var(--color-blue-1-dark);\r\n    }\r\n  \r\n    .oops {\r\n      color: var(--color-red-dark);\r\n    }\r\n  }\r\n  \r\n  .notificationHome_section {\r\n    color: var(--color-black-dark);\r\n  }\r\n  \r\n  .float-icon-left {\r\n    background-color: var(--color-red-dark);\r\n  }\r\n}\r\n","@import url(https://fonts.googleapis.com/css?family=Lato:100,300,400,700,900);\n*,\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\nion-content {\n  overflow-x: hidden;\n  overflow-y: hidden;\n  font-family: Calibri !important;\n  background-color: var(--color-blue-2-light);\n}\n\ndigim-dispatcher-home-card {\n  padding: 2px;\n}\ndigim-dispatcher-home-card ion-card-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\ndigim-dispatcher-home-card ion-card-content ion-row {\n  height: 100px;\n  width: 100% !important;\n  padding: 10px;\n}\ndigim-dispatcher-home-card ion-card-content ion-row ion-card {\n  height: 100px;\n  width: 100%;\n}\n\n.digim-button-1 {\n  --background: var(--color-blue-1-light);\n  --border-radius: 5px;\n  font-weight: lighter;\n  height: 32px;\n  width: 85px;\n  text-transform: capitalize;\n  --border-color: var(--color-blue-1-dark);\n  --border-style: solid;\n  --border-width: 1px;\n}\n\n.cards-wrapper {\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 310px);\n  justify-content: center;\n  align-content: start;\n  grid-gap: 0 1.15vw;\n  margin: 0 !important;\n  padding: 0 !important;\n  overflow-y: scroll;\n  z-index: 1;\n  transition-property: transform;\n  box-sizing: content-box;\n  background: var(--color-blue-6-light);\n}\n\n.cards-wrapper > * {\n  margin-top: 1.15vw;\n}\n\n@media screen and (max-width: 360px) {\n  .cards-wrapper {\n    grid-gap: 0 0;\n  }\n  .cards-wrapper > * {\n    margin-top: 0 !important;\n    margin: 0 !important;\n  }\n}\nion-card {\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  margin: 0 5px;\n  height: 100%;\n  overflow: visible;\n}\n\nion-content {\n  overflow-y: auto;\n}\n\n.digim-card-heading {\n  font-size: 22px;\n  color: var(--color-black-light);\n  display: inline-block;\n  text-transform: capitalize;\n  font-family: Calibri;\n  width: 90%;\n  font-weight: 600;\n}\n\nion-card-header {\n  border-radius: 10px 10px 0 0;\n  background-color: var(--color-blue-7-light);\n  padding: 10px 10px 5px 10px;\n}\n\nion-card-header ion-icon {\n  font-size: 22px;\n  color: var(--color-gray-4-light);\n  cursor: pointer;\n  vertical-align: middle;\n}\n\n.digim-small-text {\n  font-size: 10px;\n  font-weight: normal;\n  padding: 0px 0 0px 5px;\n  color: var(--color-black-light);\n  font-size: 13px;\n  text-align: center;\n  width: 100%;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.digim-ionic-card-center ion-card-content {\n  height: 200px;\n  width: 100%;\n}\n\n.digim-text-card-title {\n  display: block;\n  font-size: 4em;\n  color: var(--color-black-light);\n  text-align: center;\n  width: 100%;\n  font-family: Calibri;\n}\n\n.digim-text-card-title-small {\n  display: block;\n  font-size: 32px;\n  width: 100%;\n  color: var(--color-black-light);\n  text-align: center;\n  font-family: Calibri;\n}\n\n.digim-card-title-hour-text {\n  display: block;\n  font-size: 1rem;\n  width: 100%;\n  color: var(--color-black-light);\n  text-align: center;\n  font-family: Calibri;\n  margin: 15px 0;\n  font-weight: 600;\n}\n\n.blue-80 {\n  border-bottom: 2px solid var(--color-blue-2-light);\n  width: 80%;\n  margin: auto;\n}\n\n.weather-wrapper {\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-rows: 1fr 1fr 1fr 1fr auto;\n}\n\n@media only screen and (min-device-width: 834px) and (max-device-width: 1366px) and (orientation: portrait) {\n  .digim-ionic-card-center ion-card {\n    height: 330px;\n  }\n}\n@media only screen and (min-device-width: 834px) and (max-device-width: 1366px) and (orientation: landscape) {\n  .digim-ionic-card-center ion-card {\n    height: 330px;\n  }\n}\n/* Safari 10.1+ */\n@media not all and (min-resolution: 0.001dpcm) {\n  ion-card {\n    height: 450px;\n  }\n}\n.responsive_card {\n  background: none !important;\n}\n\n@media (min-width: 768px) {\n  .digim-card-heading {\n    padding-bottom: 10px;\n  }\n}\n.digim-notification-top-right {\n  position: absolute;\n  top: 1px;\n  right: 1px;\n}\n\n.responsive_card .digim-notification-top-right {\n  height: 30px;\n  transition: 0.6s;\n  width: 30px;\n  font-size: 16px;\n  right: -10px;\n  z-index: 1;\n  top: -10px;\n}\n\n.noLocation {\n  padding: 0px 10px;\n  font-size: 16px;\n  color: var(--color-gray-5-light);\n  text-align: center;\n}\n\n.lockedScreen {\n  text-align: center;\n  margin-top: 50px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.lockedScreen .lockedContainer {\n  background-color: var(--color-blue-0-light);\n  padding: 20px;\n  border-radius: 10px;\n}\n.lockedScreen .lock-icon {\n  width: 150px;\n  height: 150px;\n  color: var(--color-blue-1-light);\n}\n.lockedScreen .oops {\n  color: var(--color-red-light);\n}\n.lockedScreen .oops ion-icon {\n  vertical-align: middle;\n  width: 36px;\n  height: 36px;\n}\n.lockedScreen p {\n  font-size: 22px;\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 980px) {\n  .digim-button-1 {\n    font-size: 13px;\n  }\n}\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) and (orientation: landscape) {\n  .digim-button-1 {\n    font-size: 15px;\n  }\n}\n.digim-card-heading img {\n  vertical-align: middle;\n  margin-right: 8px;\n  text-align: left;\n}\n\n.notificationHome_section {\n  padding: 0 10px;\n  font-size: 14px;\n  height: 160px;\n  overflow-y: auto;\n  display: block;\n  line-height: 1.3;\n  color: var(--color-black-light);\n}\n\n.notificationHome_section ul {\n  padding: 0;\n  margin-left: 20px;\n  list-style-type: disc;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.notificationHome_section ul li {\n  margin: 5px 0;\n}\n\n.align-center {\n  text-align: center;\n  padding-top: 25%;\n  font-size: 20px;\n}\n\n.float-icon-left {\n  position: fixed;\n  z-index: 55;\n  bottom: 0;\n  cursor: pointer;\n  right: 0;\n  background-color: var(--color-red-light);\n  padding: 7px;\n  border-radius: 5px 0 0 5px;\n}\n.float-icon-left ion-icon {\n  width: 25px;\n  margin-right: 3px;\n  vertical-align: middle;\n  height: 25px;\n}\n\n/* dark theme styles */\n.digim-ion-content.dark {\n  background-color: var(--color-blue-2-dark);\n}\n\n.dark .digim-button-1 {\n  --background: var(--color-blue-1-dark);\n  --border-color: var(--color-blue-1-light);\n}\n.dark .cards-wrapper {\n  background: var(--color-blue-6-dark);\n}\n.dark .digim-card-heading {\n  color: var(--color-black-dark);\n}\n.dark ion-card-header {\n  background-color: var(--color-blue-7-dark);\n}\n.dark ion-card-header ion-icon {\n  color: var(--color-gray-4-dark);\n}\n.dark .digim-small-text {\n  color: var(--color-black-dark);\n}\n.dark .digim-text-card-title {\n  color: var(--color-black-dark);\n}\n.dark .digim-text-card-title-small {\n  color: var(--color-black-dark);\n}\n.dark .digim-card-title-hour-text {\n  color: var(--color-black-dark);\n}\n.dark .blue-80 {\n  border-bottom: 2px solid var(--color-blue-2-dark);\n}\n.dark .noLocation {\n  color: var(--color-gray-5-dark);\n}\n.dark .lockedScreen .lockedContainer {\n  background-color: var(--color-blue-0-dark);\n}\n.dark .lockedScreen .lock-icon {\n  color: var(--color-blue-1-dark);\n}\n.dark .lockedScreen .oops {\n  color: var(--color-red-dark);\n}\n.dark .notificationHome_section {\n  color: var(--color-black-dark);\n}\n.dark .float-icon-left {\n  background-color: var(--color-red-dark);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
